"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var props_1 = require("../../../context/props");
var useStyles_1 = __importDefault(require("./useStyles"));
var index_1 = require("../../../../index");
var useContentCellPropertiesWithoutLabel_1 = __importDefault(require("./useContentCellPropertiesWithoutLabel"));
var DataGridMobileCellContent = function (props) {
    var rowData = props.rowData, column = props.column, rowIndex = props.rowIndex, _a = props.column, id = _a.id, CellComponent = _a.cellComponent, label = _a.label;
    var classes = (0, useStyles_1.default)();
    var cellProps = (0, props_1.usePropsContext)().cellProps;
    var contentCellPropertiesWithoutLabel = (0, useContentCellPropertiesWithoutLabel_1.default)();
    var value = rowData[id];
    var content = CellComponent
        ? (react_1.default.createElement(CellComponent, { value: value, column: column, rowData: rowData, cellProps: cellProps, rowIndex: rowIndex })) : value;
    return (react_1.default.createElement(TableRow_1.default, { key: id, classes: { root: classes.tableRowRoot } },
        label && (react_1.default.createElement(TableCell_1.default, { size: "small" },
            react_1.default.createElement(index_1.Typography, { variant: "caption" },
                react_1.default.createElement("b", null, label)))),
        react_1.default.createElement(TableCell_1.default, __assign({ size: "small", align: "right" }, !label && contentCellPropertiesWithoutLabel),
            react_1.default.createElement(index_1.Typography, { variant: "caption" }, content))));
};
exports.default = DataGridMobileCellContent;
